import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetAccessesDetail, HttpGetAccessesDetailOptions, HttpGetAccessesDetailResponse} from '../http/accesses.http'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'

export const useGetAccessesDetail = ({
    params,
    options
}: {
    params: HttpGetAccessesDetailOptions['params']
    options?: Omit<
        UseQueryOptions<HttpGetAccessesDetailResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn' | 'retry'
    >
}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ACCESSES_DETAIL, params.projectId, params.responseType],
        queryFn: () => httpGetAccessesDetail({params}),
        retry: false,
        ...options
    })
}
